import { fg } from '@atlassian/jira-feature-gating';

const Nav4SidebarEmptyOnDbErrorRelayProvider = {
	get(): boolean {
		return fg('sea-4061-nav4-sidebar-empty-on-db-error');
	},
};

export default Nav4SidebarEmptyOnDbErrorRelayProvider;
